<template>
<!-- 
    * Copyright: T-Systems México S.A. de C.V.
    * Descripción: Vista atributos de salas de juntas, permite consultar, crear, editar y eliminar atributos disponibles para las salas de juntas
    * Autor: 
    * F.Creación: 
  -->
  <layout :title="$t('moduleTitle')">
    <!-- Contenido -->
    <template v-slot:content>
      <!-- modal con formulario para asociar un atributo a una sala de juntas-->
      <v-dialog persistent v-model="newDialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("tblbutton")}}</v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="newMapForm" lazy-validation>
                <v-col cols="12">
                  <v-select v-model="selected" :label="$t('moduleTitle')" :items="checkbox_options"></v-select>
                </v-col>
                <v-row align="center" justify="center">
                  <v-col cols="12" v-for="(option, i) in checkbox_options" :key="i">
                    <v-col cols="12" v-if="option.value == selected">
                      <v-col cols="12" v-if="option.attributeType == 2">
                        <v-text-field v-model="currentatributtes.nValue" :label="$t('lblMinValue')"></v-text-field>
                      </v-col>
                      <v-col cols="12" v-if="option.attributeType == 6 || option.attributeType == 1">
                        <v-text-field v-model="currentatributtes.sValue" :label="$t('lblmMxValue')"></v-text-field>
                      </v-col>
                    </v-col>
                  </v-col>
                  <v-col cols="12">
                    <p class="caption error--text" v-html="errorMessage"></p>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <div v-for="(option, i) in checkbox_options" :key="i">
            <v-card-actions v-if="option.value == selected">
              <v-spacer></v-spacer>
              <v-btn text @click.stop="doNewDialog(option)" color="primary">{{$t("mdlSave")}}</v-btn>
            </v-card-actions>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeNewDialog()">{{$t("mdlCancel")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- modal con formulario para editar un atributo asociado a una sala de juntas-->
      <v-dialog persistent v-model="uploadDialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("dlgUploadTitle")}}</v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="newMapForm" lazy-validation>
                <v-row>
                  <v-col cols="12" v-if="currentatributtes.attributeType==2">
                    <v-text-field v-model="currentatributtes.nValue" :label="$t('lblMinValue')"></v-text-field>
                  </v-col>
                  <v-col cols="12" v-if="currentatributtes.attributeType==6">
                    <v-text-field v-model="currentatributtes.sValue" :label="$t('lblmMxValue')"></v-text-field>
                  </v-col>
                  <v-col cols="12" v-if="currentatributtes.attributeType==1">
                    <v-text-field v-model="currentatributtes.sValue" :label="$t('lblmMxValue')"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <p class="caption error--text" v-html="errorMessage"></p>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeUploadDialog()">{{$t("mdlCancel")}}</v-btn>
            <v-btn text @click.stop="doUploadDialog()" color="primary">{{$t("mdlSave")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- modal con formulario para eliminar un atributo asociado a una sala de juntas-->
      <v-dialog persistent v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("dlgDeleteMapTitle")}}</v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-alert outlined type="warning" prominent border="left">
                    {{$t('lbldelete1')}}
                    <br />
                    <strong>{{currentatributtes.attributeName}}</strong>
                    <br />
                    {{$t('lbldelete2')}}
                  </v-alert>
                </v-col>
                <v-col cols="12">
                  <p class="caption error--text" v-html="errorMessage"></p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeDeleteDialog()">{{$t("mdlCancel")}}</v-btn>
            <v-btn text @click.stop="doDeleteDialog()" color="primary">{{$t("mdlSave")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- caja de texto para buscar informacion en tabla de contenido -->
      <v-text-field
        solo
        class="mt-4"
        :label="$t('lblSearch')"
        prepend-inner-icon="mdi-account"
        v-model="search"
      ></v-text-field>
      <!-- Boton navegacion hacia atras -->
      <router-link
        class="white--text"
        v-if="$routerHistory.hasPrevious()"
        :to="{ path: $routerHistory.previous().path }"
      >
        <v-btn class="mb-2" tile color="primary">
          <v-icon left>mdi-chevron-left</v-icon>{{$t('lblback')}}
        </v-btn>
      </router-link>
      <!-- nombre : {{meetingRooms[0].name}}  -->
      <!-- Tabla de contenido -->
      <v-data-table
        :headers="headers"
        :items="atributtes"
        :loading="isLoading"
        :search="search"
        loading-text="Cargando elementos en tabla"
        color="primary"
      >
        <template v-slot:top>
          <v-toolbar flat color="primary">
            <v-toolbar-title class="white--text">{{$t('tblTitle',{ name: meetingRooms[0].name } )}}  </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              @click.stop="newDialog = true"
            >{{$t('tblbutton')}}</v-btn>
          </v-toolbar>
        </template>
        <!-- Panel de acciones -->
        <template v-slot:item.action="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon class="mr-2" color="grey" v-on="on" @click="showUploadDialog(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>{{$t('lblEdit')}}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon class="mr-2" color="grey" v-on="on" @click="showDeleteDialog(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>{{$t('lblDelete')}}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-snackbar v-model="snackbar">
        {{ mensaje }}
        <v-btn color="primary" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </template>
  </layout>
</template>

<script>
// Incluimos el LAYOUT estandar para los usuario que ya tienen
// una sesión activa
import Layout from "@/components/Layouts/company";
// Incluimos los mensajes de esta pantalla
import i18nMessages from "./i18n.messages";
import { mapGetters } from "vuex";

export default {
  // Se definen los componentes requeridos por esta pantalla
  components: {
    layout: Layout
  },
  created() {
    this.$i18n.locale = this.locale;
    // Obtenemos la lista de atributos ligados a sala de juntas
    this.loadData();
    // Obtenemos la lista de atributos para asociarlo a selector
    this.loadSelect();
    this.loadName();
    
    //inicializamos encabezados de la tabla
    this.updateHeadersLocale();
  },
  beforeDestroy() {},
  i18n: i18nMessages,
  data: function() {
    return {
      //variables de control para cuadro de dialogo
      newDialog: false,
      deleteDialog: false,
      uploadDialog: false,
      viewDialog: false,
      dialogHelp: false,
      selected: null,
      typeAtrib: null,
      //variables  para control de validaciones
      snackbar: false,
      mensaje: "",
      search: "",
      nombre: "",
      meetingRooms: [],
      loading: true,
      dialog: false,
      //arreglo para almacenar los atributos
      atributtes: [],
       //arreglo para almacenar cambios de atributos
      currentatributtes: { resource: {} },
      errorMessage: "",
      //encabezados de la tabla
      headers: [
        { id: "headerName", text: "Nombre", value: "attributeName" },
        { id: "headerValue", text: "Valor", value: "value", sortable: true },
        // { text: "Descripcion", value: "sValue", sortable: true },
        {
          id: "headerAction",
          text: "Acciones",
          value: "action",
          sortable: false
        }
      ],
      checkbox_options: []
    };
  },
  mounted: () => {},
  computed: {
    ...mapGetters(["isLoading"]),
    locale() {
      return this.$store.getters["locale"];
    },
    formTitle() {
      return this.editedItem.id === null
        ? "Nueva Ubicación"
        : "Editar Ubicación";
    }
  },
  watch: {
    locale(value) {
      this.$i18n.locale = value;
      this.updateHeadersLocale();
    }
  },
  methods: {
    // Actualiza el idioma de los encabezados de la tabla
    updateHeadersLocale() {
      this.headers = this.headers.map(header => {
        header.text = this.$t(header.id);
        return header;
      });
    },
    //consulta de atributos desde lambda, asignacion de datos a arreglo atributo
    loadSelect() {
      //** console.log("invocaion loadData");
      let settings = {
        itemTypeId: this.$route.params.idItemType
      };
      this.$GET("/api/itemTypes/{{itemTypeId}}/attributes", settings)
        .then(atributtes => {
          this.checkbox_options = atributtes.map(item => {
            return {
              value: item.id,
              text: item.name,
              minValue: item.minValue,
              maxValue: item.maxValue,
              attributeType: item.attributeType
            };
          });
          //** console.log("atributtes: ", this.checkbox_options);
        })
        .catch(() => { 
          //** console.log(e)
        });
    },
    loadName() {
      //** console.log("invocaion loadData");
      let settings = {
        locationId: this.$route.params.idLocation,
        itemTypeId: this.$route.params.idItemType
      };
      this.$GET("/api/locations/{{locationId}}/items/{{itemTypeId}}", settings)
        .then(meetingRooms => {
          this.meetingRooms = meetingRooms.map(item => {
            //if(item.id == this.$route.params.idMeetingRoom){
              return {
                id: item.id,
                name: item.name,
            };
           // }
          });
           //console.log("MeetingRooms: ", this.meetingRooms);
           this.reLoadName();
        })
        .catch(() => {
          //** console.log(e)
        });
        
    },
    reLoadName(){
      console.log("ejecutando reloadname");
        this.meetingRooms = this.meetingRooms.filter(item =>{
              return  item.id == this.$route.params.idMeetingRoom;
        })
        console.log(this.meetingRooms)
    },    
    loadData() {
      //** console.log("invocaion loadData");
      let settings = {
        itemId: this.$route.params.idMeetingRoom
      };
      this.$GET("/api/items/{{itemId}}/attributes", settings)
        .then(atributtes => {
          this.atributtes = atributtes.map(item => {
            // TODO: eliminar cuando la lambda ya este lista
            // Este bloque solo se utiliza para fines de pruebas
            // ============
            /* item.attributeType = 1;
            item.minValue = 1;
            item.maxValue = 50; */
            // ============
            
            if (item.attributeType === 2) {
              item.value = item.nValue;
            } else if (item.attributeType === 6) {
              item.value = item.sValue;
            }
            else if (item.attributeType === 1) {
              if(item.sValue == "" || item.sValue == null || item.sValue == " "){
                item.value = "-";
              }else{
              item.value = item.sValue;
              }
            }
            return item;
          });
           //console.log("atributtes: ", this.atributtes);
        })
        .catch(() => { 
          //** console.log(e)
        });
    },

    closeNewDialog() {
      this.newDialog = false;
      this.currentatributtes = { resource: {} };
      this.errorMessage = "";
    },
    doNewDialog(item) {
      if (this.selected == null) {
        this.errorMessage =
          "debes de seleccionar un atributo de forma obligatoria";
        //Valor tipo Tiene/No tiene
      } else if (item.attributeType == 1) {
        this.currentatributtes.nValue = 0;
        if (this.currentatributtes.sValue == null){
          this.currentatributtes.sValue = " ";
        }
        let payload = {
          params: {
            itemId: this.$route.params.idMeetingRoom,
            attributeId: this.selected
          },
          data: {
            nValue: this.currentatributtes.nValue,
            sValue: this.currentatributtes.sValue
            // lastUpdate: this.currentatributtes.lastUpdate
          }
        };
        /*
        //** console.log(
          "/api/items/{{itemId}}/attributes/{{attributeId}}",
          payload
        );
        */
        this.$POST("/api/items/{{itemId}}/attributes/{{attributeId}}", payload)
          .then(() => {
            //** console.log(response);
            this.loadData();
            this.loadSelect();
            this.newDialog = false;
            this.errorMessage = "";
          })
          .catch(e => {
            // En caso de error presentar un mensaje
            // al usuario
            //** console.log(e);
            this.errorMessage = e;
          })
          .finally(() => {});
        //Valor númerico (Capacidad, etc)
      } else if (item.attributeType == 2) {
        if (this.currentatributtes.nValue > item.maxValue) {
          this.errorMessage = "El numero maximo permitido es " + item.maxValue;
        } else if (
          this.currentatributtes.nValue < item.minValue ||
          this.currentatributtes.nValue == null
        ) {
          this.errorMessage = "El numero minimo permitido es " + item.minValue;
        } else {
          this.currentatributtes.sValue = " ";
          let payload = {
            params: {
              itemId: this.$route.params.idMeetingRoom,
              attributeId: this.selected
            },
            data: {
              nValue: this.currentatributtes.nValue,
              sValue: this.currentatributtes.sValue
              // lastUpdate: this.currentatributtes.lastUpdate
            }
          };
          /*
          //** console.log(
            "/api/items/{{itemId}}/attributes/{{attributeId}}",
            payload
          );
          */
          this.$POST(
            "/api/items/{{itemId}}/attributes/{{attributeId}}",
            payload
          )
            .then(() => {
              //** console.log(response);
              this.loadData();
              this.loadSelect();
              this.newDialog = false;
              this.errorMessage = "";
            })
            .catch((e) => {
              // En caso de error presentar un mensaje
              // al usuario
              //** console.log(e);
              this.errorMessage = e;
            })
            .finally(() => {});
        }
        //Valor tipo numérico contextualizado
      } else if (item.attributeType == 6) {
        this.currentatributtes.nValue = 0;
        let payload = {
          params: {
            itemId: this.$route.params.idMeetingRoom,
            attributeId: this.selected
          },
          data: {
            nValue: this.currentatributtes.nValue,
            sValue: this.currentatributtes.sValue
            // lastUpdate: this.currentatributtes.lastUpdate
          }
        };
        /*
        //** console.log(
          "/api/items/{{itemId}}/attributes/{{attributeId}}",
          payload
        );
        */
        this.$POST("/api/items/{{itemId}}/attributes/{{attributeId}}", payload)
          .then(() => {
            //** console.log(response);
            this.loadData();
            this.loadSelect();
            this.newDialog = false;
            this.errorMessage = "";
          })
          .catch((e) => {
            // En caso de error presentar un mensaje
            // al usuario
            //** console.log(e);
            this.errorMessage = e;
          })
          .finally(() => {});
      }
    },
    showUploadDialog(item) {
      this.currentatributtes = item;
      this.uploadDialog = true;
    },
    closeUploadDialog() {
      this.uploadDialog = false;
      this.currentatributtes = { resource: {} };
      this.$refs.updateMapForm.reset();
      this.errorMessage = "";
    },
    doUploadDialog() {
      let payload = {
        params: {
          itemId: this.$route.params.idMeetingRoom,
          attributeId: this.currentatributtes.attributeId
        },
        data: {
          nValue: this.currentatributtes.nValue,
          sValue: this.currentatributtes.sValue,
          lastUpdate: this.currentatributtes.lastUpdate
        }
      };
      //** console.log("/api/items/{{itemId}}/attributes/{{attributeId}}", payload);
      this.$PUT("/api/items/{{itemId}}/attributes/{{attributeId}}", payload)
        .then(() => {
          //** console.log(response);
          this.loadData();
          this.loadSelect();
          this.uploadDialog = false;
        })
        .catch(() => {
          // En caso de error presentar un mensaje
          // al usuario
          //** console.log(e);
          this.errorMessage = "Ocurrió un error actualizar el atributo";
        })
        .finally(() => {});
    },
    showDeleteDialog(item) {
      this.currentatributtes = item;
      this.deleteDialog = true;
    },
    closeDeleteDialog() {
      this.deleteDialog = false;
      this.currentatributtes = { resource: {} };
      this.errorMessage = "";
    },
    doDeleteDialog() {
      let payload = {
        params: {
          itemId: this.$route.params.idMeetingRoom,
          attributeId: this.currentatributtes.attributeId
        },
        data: {
          lastUpdate: this.currentatributtes.lastUpdate
        }
      };
      //** console.log("/api/items/{{itemId}}/attributes/{{attributeId}}", payload);
      this.$DELETE("/api/items/{{itemId}}/attributes/{{attributeId}}", payload)
        .then(() => {
          //** console.log(response);
          this.loadData();
          this.loadSelect();
          this.closeDeleteDialog();
          this.errorMessage = "";
        })
        .catch(() => {
          // En caso de error presentar un mensaje
          // al usuario
          this.currentatributtes = { resource: {} };
          //** console.log(e);
          this.errorMessage = "Ocurrió un error al eliminar atributo";
        })
        .finally(() => {});
    }
  }
};
</script>